import { render, staticRenderFns } from "./add-menu.vue?vue&type=template&id=901ad9ac"
import script from "./add-menu.vue?vue&type=script&lang=ts"
export * from "./add-menu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports